import InlineDiffViewer from "../../Comment/InlineDiffViewer";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/sudokit/components/Dialog";
import { SudoButton } from "src/sudokit/components/SudoButton";

export interface FeedbackApplyConfirmationDetails {
  originalText: string;
  currentText: string;
  suggestionText: string;
}

interface FeedbackApplyConfirmationDialogProps {
  details: FeedbackApplyConfirmationDetails | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function FeedbackApplyConfirmationDialog({
  details,
  onCancel,
  onConfirm,
}: FeedbackApplyConfirmationDialogProps) {
  return (
    <Dialog
      open={Boolean(details)}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>The highlighted text has changed</DialogTitle>
          <DialogDescription>
            This passage has change since Feedback was generated. Review the changes before replacing the current highlighted text with this suggestion.
          </DialogDescription>
        </DialogHeader>

        {details && (
          <div className="mt-5 flex flex-col gap-4 text-app-grey-0">
            <section aria-label="Changes to the highlighted text">
              <h3 className="m-0 mb-2 text-sm font-semibold text-app-grey-1">
                Changes since Feedback was generated
              </h3>
              <div className="rounded-xl border border-solid border-app-grey-3 bg-app-grey-4 p-4 text-base leading-relaxed">
                <InlineDiffViewer
                  string1={details.originalText}
                  string2={details.currentText}
                  cleanUp="semantic"
                  diffUnit="word"
                />
              </div>
            </section>

            <section aria-label="Incoming Feedback suggestion">
              <h3 className="m-0 mb-2 text-sm font-semibold text-app-grey-1">
                Incoming suggestion
              </h3>
              <div className="whitespace-pre-wrap rounded-xl border border-solid border-app-grey-3 bg-app-grey-4 p-4 text-base leading-relaxed">
                {details.suggestionText}
              </div>
            </section>
          </div>
        )}

        <DialogFooter>
          <SudoButton variant="tertiaryGrey" onClick={onCancel}>
            Cancel
          </SudoButton>
          <SudoButton variant="primary" onClick={onConfirm}>
            Apply anyway
          </SudoButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
